<template>
  <!-- 二维码弹框 -->
  <div class="trial_dialog_box" v-show="dialogShow">
    <div class="trial_dialog_mask" @click="trial_dialog_or_window_hide()"></div>
    <div class="form_box">
      <div @click="trial_dialog_or_window_hide()" class="el-icon-circle-close iconfont"></div>
      <div v-show="formShow" class="form_not_submit">
        <img class="code-img" src="@/assets/images/landing-ofd/qrCode.png" alt="" />
        <div class="code-text">扫码获取方案详情</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogShow: false,
      formShow: true,
    }
  },
  methods: {
    /**
     *显示二维码弹框
     */
    showQrCodeDialog() {
      this.dialogShow = true
    },

    // 隐藏二维码弹框
    trial_dialog_or_window_hide() {
      this.dialogShow = false
    },
  },
}
</script>

<style lang="less" scoped>
.trial_dialog_box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999999;
  // display: none;
}
.trial_dialog_box .trial_dialog_mask {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background: #000;
}

.trial_dialog_box .form_box {
  box-sizing: border-box;
  background: #E63740;
  width: 237px;
  height: 288px;
  max-width: 90%;
  min-height: 288px;
  padding: 3px 3px 3px;
  border-radius: 8px 8px 16px 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .form_not_submit{
    .code-text{
        font-size: 20px;
        color: #FFFFFF;
        text-align: center;
        padding-top: 12px;
    }
  }
}

.trial_dialog_box .form_box .el-icon-circle-close {
  font-size: 26px;
  position: absolute;
  top: -22px;
  right: -22px;
  color: #c4c5c9;
  cursor: pointer;
}
</style>
